import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import UnSelectedOverviewIcon from "../../svg/Ads_Dashboard_Developement2/UnSelectedNavIcon/OverviewIcon/elements.svg";
import SelectedOverviewIcon from "../../svg/Ads_Dashboard_Developement2/SelectedNavIcon/OverviewIcon/elements.svg";
import UnSelectedSalesAnalysisIcon from "../../svg/Ads_Dashboard_Developement2/UnSelectedNavIcon/SalesAnalysisIcon/elements.svg";
import SelectedSalesAnalysisIcon from "../../svg/Ads_Dashboard_Developement2/SelectedNavIcon/SalesAnalysisIcon/elements.svg";
import SelectedTargetingAnalysisIcon from "../../svg/Ads_Dashboard_Developement2/SelectedNavIcon/TargetingAnalysisIcon/elements.svg";
import UnSelectedTargetingAnalysisIcon from "../../svg/Ads_Dashboard_Developement2/UnSelectedNavIcon/TargetingAnalysisIcon/elements.svg";
import SelectedMappingData from "../../svg/Ads_Dashboard_Developement2/MappingDataIcon/elements.svg";
import UnSelectedMappingData from "../../svg/Ads_Dashboard_Developement2/UnSelectedMappingDataIcon/elements.svg";
import IIcon from "../../svg/Ads_Dashboard_Developement2/IIcon/elements.svg";
import UserProfile from "../../svg/Ads_Dashboard_Developement2/UserProfileIcon/elements.svg";
import { Tooltip } from "@mui/joy";
import appError from "../../appError";
import axios from "axios";
import { BASE_URL, WHITE } from "../../appConstants";
import { useSelector } from "react-redux";
type RangeProps = {
  min_date: Date;
  max_date: Date;
};
const Ads_Dashboard_Management: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {brand_id} = useParams();
  const [Brandrange, setBrandRange] = useState<RangeProps | null>(null);

  const getBrandRange = async () => {
    const token = localStorage.getItem("token");
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getBrandRange?brand_id=${brand_id}`;
      const result = await axios.get(api, { headers });
      const { range } = result?.data?.data;
      if (range) {
        setBrandRange({
          min_date: new Date(range[0]._col0.split("T")[0]),
          max_date: new Date(range[0]._col1.split("T")[0]),
        });
        let localstorageRange = {
          min_date: range[0]._col0,
          max_date: range[0]._col1
        }
        localStorage.setItem("BrandRange", JSON.stringify(localstorageRange));
      }
    } catch (error) {
      appError(error);
    }
  };
  
  useEffect(() => {
    if (brand_id) {
      getBrandRange();
    }
  }, [brand_id]);

  const IconTooltip: React.FC<{ name: string }> = ({ name }) => {
    return (
      <div
        className=" p-2 rounded-[4px]"
        style={{ backgroundColor: "#3C3C3F" }}
      >
        <div
          style={{
            color: "var(--Text-Primary-White, #FFF)",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "18px",
          }}
        >
          {name}
        </div>
      </div>
    );
  };

  const RangeTooltip: React.FC<{ date1: string; date2: string }> = ({
    date1,
    date2,
  }) => {
    return (
      <div
        className="inline-flex flex-col items-start gap-2 rounded-[8px]"
        style={{ backgroundColor: "#3C3C3F" }}
      >
        <div className="flex items-center self-stretch gap-2">
          <div
            style={{
              color: "var(--Text-Primary-White, #97979A)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            Data Available From
          </div>
          <div
            style={{
              color: "var(--Text-Primary-White, #FFF)",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "18px",
            }}
          >
            {date1}
          </div>
        </div>
        <div className="flex items-center self-stretch gap-2">
          <div
            style={{
              color: "var(--Text-Primary-White, #97979A)",
              fontFamily: "Inter",
              fontSize: "10px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "10px",
              letterSpacing: "1.6px",
              textTransform: "uppercase",
            }}
          >
            Data Available Till
          </div>
          <div
            style={{
              color: "var(--Text-Primary-White, #FFF)",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "18px",
            }}
          >
            {date2}
          </div>
        </div>
      </div>
    );
  };

  const RangeToolTip2: React.FC<{ lastest_Refresh_Date: Date, Ads_Range: RangeProps, Seller_Range: RangeProps, Vendor_Range: RangeProps }> = ({
    lastest_Refresh_Date, Ads_Range, Seller_Range, Vendor_Range
  }) => {

    return (
      <div className="flex flex-col gap-2" style={{
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "14px",
        fontFamily: "Inter"
      }}>
          <div className="">
             {`Last Refresh Date : ${String(lastest_Refresh_Date?.getDate()).padStart(
                  2,
                  "0"
                )}/${String(
                  lastest_Refresh_Date?.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${lastest_Refresh_Date?.getFullYear()}`}
          </div>

          <table className="">
              <thead className="" >
                <th className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`, 
              }}></th>
                <th className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>Ads</th>
                <th className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>Seller</th>
                <th className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>Vendor</th>
              </thead>
              <tbody className="">
                <tr>
                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>Data Available From</td>

                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>{`${String(Ads_Range?.min_date?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    Ads_Range?.min_date?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${Ads_Range?.min_date?.getFullYear()}`}</td>

                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>{`${String(Seller_Range?.min_date?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    Seller_Range?.min_date?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${Seller_Range?.min_date?.getFullYear()}`}</td>

                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>{`${String(Vendor_Range?.min_date?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    Vendor_Range?.min_date?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${Vendor_Range?.min_date?.getFullYear()}`}</td>
                </tr>
                <tr className="">
                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>Data Available Till</td>

                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>{`${String(Ads_Range?.max_date?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    Ads_Range?.max_date?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${Ads_Range?.max_date?.getFullYear()}`}</td>
                  
                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>{`${String(Seller_Range?.max_date?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    Seller_Range?.max_date?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${Seller_Range?.max_date?.getFullYear()}`}</td>

                  <td className="flex-1 p-2" style={{
                    border: `1px solid #EAEAED`,
              }}>{`${String(Vendor_Range?.max_date?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    Vendor_Range?.max_date?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${Vendor_Range?.max_date?.getFullYear()}`}</td>
                </tr>
              </tbody>
          </table>
      </div>
    )
  }

  return (
    <div className="flex">
      <div
        className="flex w-[72px] py-5 px-[14px] items-center gap-1 "
        style={{
          height: "calc(100vh - 72px)",
          backgroundColor: "#1C1C1E",
        }}
      >
        <div className="flex w-[43px] h-full flex-col justify-between items-center">
          <div className="flex flex-col items-center gap-[60px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="43"
              height="24"
              viewBox="0 0 43 24"
              fill="none"
            >
              <path
                d="M42.7664 12.0018L38.9389 17.2663L34.0478 24L30.2203 18.7354L35.1114 12.0018L30.2203 5.26812L34.0478 0L38.9389 6.73366L42.7664 12.0018Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M7.88862 12.0018L12.7797 18.7354L8.9522 24L4.06114 17.2663L0.233656 12.0018L4.06114 6.73366L8.9522 0L12.7797 5.26812L7.88862 12.0018Z"
                fill="white"
                fill-opacity="0.1"
              />
              <path
                d="M30.2204 5.26812L25.3257 12.0018L30.2204 18.7354L34.0478 24H26.3929L21.5018 17.2663L16.6072 24H8.95224L12.7797 18.7354L17.6743 12.0018L12.7797 5.26812L8.95224 0H16.6072L21.5018 6.73366L26.3929 0H34.0478L30.2204 5.26812Z"
                fill="url(#paint0_linear_445_4556)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_445_4556"
                  x1="8.95224"
                  y1="23.8982"
                  x2="34.4437"
                  y2="2.38922e-06"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#F879FF" />
                  <stop offset="0.517684" stop-color="#57A6FF" />
                  <stop offset="1" stop-color="#50F8FF" />
                </linearGradient>
              </defs>
            </svg>

            <div className="flex flex-col items-start gap-6">
              <Tooltip
                title={<IconTooltip name="Overview" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {location.pathname.includes("overview") ? (
                  <img
                    src={SelectedOverviewIcon}
                    alt="OverView Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/Ads_dashboard/overview/comparison/${brand_id}`)
                    }
                  />
                ) : (
                  <img
                    src={UnSelectedOverviewIcon}
                    alt="OverView Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/Ads_dashboard/overview/comparison/${brand_id}`)
                    }
                  />
                )}
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="Sales Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {location.pathname.includes("salesAnalysis") ? (
                  <img
                    src={SelectedSalesAnalysisIcon}
                    alt="Sales Analysis Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/Ads_dashboard/salesAnalysis/comparison/${brand_id}`)
                    }
                  />
                ) : (
                  <img
                    src={UnSelectedSalesAnalysisIcon}
                    alt="Sales Analysis Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/Ads_dashboard/salesAnalysis/comparison/${brand_id}`)
                    }
                  />
                )}
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="Ads Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {location.pathname.includes("adsAnalysis") ? (
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/Ads_dashboard/adsAnalysis/comparison/${brand_id}`)
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M10.4994 6.57683C9.40973 6.57683 8.48351 6.95822 7.72073 7.721C6.95796 8.48377 6.57657 9.41 6.57657 10.4997C6.57657 11.3666 6.83015 12.1453 7.33732 12.8356C7.84433 13.526 8.51402 14.0071 9.34638 14.2789C9.51403 14.3364 9.65351 14.4363 9.76481 14.5787C9.87612 14.7213 9.91566 14.8764 9.88343 15.0439C9.85105 15.2079 9.77766 15.3364 9.66324 15.4292C9.54898 15.5221 9.41759 15.5524 9.26909 15.52C8.10998 15.2278 7.16904 14.6174 6.44627 13.6889C5.72366 12.7601 5.36235 11.6971 5.36235 10.4997C5.36235 9.07469 5.86228 7.86227 6.86214 6.86241C7.862 5.86255 9.07442 5.36262 10.4994 5.36262C11.6848 5.36262 12.7419 5.72393 13.6706 6.44654C14.5992 7.16931 15.2125 8.10129 15.5106 9.2425C15.5491 9.39085 15.5189 9.52372 15.42 9.64109C15.3212 9.75846 15.1898 9.8363 15.0259 9.87459C14.8521 9.90697 14.697 9.86899 14.5605 9.76064C14.424 9.6523 14.327 9.51126 14.2695 9.33754C13.9977 8.50533 13.5167 7.83713 12.8263 7.33292C12.136 6.82886 11.3604 6.57683 10.4994 6.57683ZM10.4994 3.2144C8.47572 3.2144 6.75559 3.92269 5.339 5.33927C3.92242 6.75585 3.21413 8.47599 3.21413 10.4997C3.21413 12.5522 3.90654 14.2616 5.29137 15.6279C6.6762 16.9942 8.37633 17.7036 10.3918 17.7562C10.5748 17.7598 10.7265 17.8203 10.8469 17.9377C10.9674 18.055 11.0228 18.2053 11.0131 18.3886C11.0035 18.5561 10.9394 18.7021 10.8209 18.8266C10.7023 18.9512 10.5593 19.0087 10.3918 18.9992C9.21694 18.9824 8.11761 18.7437 7.09378 18.2833C6.0701 17.8229 5.181 17.2075 4.42648 16.437C3.67211 15.6664 3.07909 14.7704 2.64742 13.7489C2.21575 12.7275 1.99992 11.6445 1.99992 10.4997C1.99992 9.32018 2.22143 8.21797 2.66446 7.19305C3.1075 6.16797 3.71671 5.26774 4.49209 4.49236C5.26747 3.71697 6.1716 3.10776 7.20446 2.66473C8.23716 2.2217 9.33548 2.00018 10.4994 2.00018C12.8296 2.00018 14.8126 2.80756 16.4484 4.42231C18.084 6.03705 18.9264 8.03171 18.9756 10.4063C18.9791 10.5643 18.9216 10.7002 18.803 10.814C18.6845 10.9278 18.5493 10.9894 18.3972 10.9989C18.2295 11.0086 18.087 10.9541 17.9696 10.8355C17.8523 10.717 17.784 10.5739 17.7648 10.4063C17.6834 8.36578 16.9779 6.657 15.6481 5.27996C14.3184 3.90292 12.6022 3.2144 10.4994 3.2144ZM17.501 18.6578L13.9606 15.0763L13.2277 16.9479C13.1559 17.1168 13.0317 17.1988 12.855 17.194C12.6785 17.1891 12.5651 17.1023 12.5148 16.9334L10.7061 11.1894C10.6713 11.0302 10.7033 10.9011 10.802 10.8023C10.9009 10.7036 11.0299 10.6716 11.1892 10.7063L16.9331 12.515C17.102 12.5653 17.1889 12.6787 17.1937 12.8553C17.1985 13.0319 17.1165 13.1562 16.9476 13.2279L15.0761 13.9375L18.6487 17.5013C18.8007 17.6532 18.8768 17.8459 18.8768 18.0794C18.8768 18.3129 18.8007 18.5057 18.6487 18.6578C18.4966 18.8099 18.3052 18.8859 18.0747 18.8859C17.8442 18.8859 17.6529 18.8099 17.501 18.6578Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                ) : (
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/Ads_dashboard/adsAnalysis/comparison/${brand_id}`)
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M10.4994 6.57683C9.40973 6.57683 8.48351 6.95822 7.72073 7.721C6.95796 8.48377 6.57657 9.41 6.57657 10.4997C6.57657 11.3666 6.83015 12.1453 7.33732 12.8356C7.84433 13.526 8.51402 14.0071 9.34638 14.2789C9.51403 14.3364 9.65351 14.4363 9.76481 14.5787C9.87612 14.7213 9.91566 14.8764 9.88343 15.0439C9.85105 15.2079 9.77766 15.3364 9.66324 15.4292C9.54898 15.5221 9.4176 15.5524 9.26909 15.52C8.10998 15.2278 7.16904 14.6174 6.44628 13.6889C5.72366 12.7601 5.36236 11.6971 5.36236 10.4997C5.36236 9.07469 5.86229 7.86227 6.86214 6.86241C7.862 5.86255 9.07442 5.36262 10.4994 5.36262C11.6848 5.36262 12.7419 5.72393 13.6706 6.44654C14.5992 7.16931 15.2125 8.10129 15.5106 9.2425C15.5491 9.39085 15.5189 9.52372 15.42 9.64109C15.3212 9.75846 15.1898 9.8363 15.0259 9.87459C14.8521 9.90697 14.697 9.86899 14.5605 9.76064C14.424 9.6523 14.327 9.51126 14.2695 9.33754C13.9978 8.50533 13.5167 7.83713 12.8263 7.33292C12.136 6.82886 11.3604 6.57683 10.4994 6.57683ZM10.4994 3.2144C8.47572 3.2144 6.75559 3.92269 5.33901 5.33927C3.92242 6.75585 3.21413 8.47599 3.21413 10.4997C3.21413 12.5522 3.90654 14.2616 5.29137 15.6279C6.6762 16.9942 8.37633 17.7036 10.3918 17.7562C10.5748 17.7598 10.7265 17.8203 10.8469 17.9377C10.9674 18.055 11.0228 18.2053 11.0131 18.3886C11.0035 18.5561 10.9394 18.7021 10.8209 18.8266C10.7023 18.9512 10.5593 19.0087 10.3918 18.9992C9.21694 18.9824 8.11761 18.7437 7.09378 18.2833C6.0701 17.8229 5.181 17.2075 4.42648 16.437C3.67211 15.6664 3.07909 14.7704 2.64742 13.7489C2.21575 12.7275 1.99992 11.6445 1.99992 10.4997C1.99992 9.32018 2.22143 8.21797 2.66447 7.19305C3.1075 6.16797 3.71671 5.26774 4.49209 4.49236C5.26748 3.71697 6.1716 3.10776 7.20446 2.66473C8.23716 2.2217 9.33548 2.00018 10.4994 2.00018C12.8296 2.00018 14.8126 2.80756 16.4484 4.42231C18.084 6.03705 18.9264 8.03171 18.9756 10.4063C18.9791 10.5643 18.9216 10.7002 18.803 10.814C18.6845 10.9278 18.5493 10.9894 18.3972 10.9989C18.2295 11.0086 18.087 10.9541 17.9696 10.8355C17.8523 10.717 17.784 10.5739 17.7648 10.4063C17.6834 8.36578 16.9779 6.657 15.6481 5.27996C14.3184 3.90292 12.6022 3.2144 10.4994 3.2144ZM17.501 18.6578L13.9606 15.0763L13.2277 16.9479C13.1559 17.1168 13.0317 17.1988 12.855 17.194C12.6785 17.1891 12.5651 17.1023 12.5148 16.9334L10.7061 11.1894C10.6713 11.0302 10.7033 10.9011 10.802 10.8023C10.9009 10.7036 11.0299 10.6716 11.1892 10.7063L16.9331 12.515C17.102 12.5653 17.1889 12.6787 17.1937 12.8553C17.1985 13.0319 17.1165 13.1562 16.9476 13.2279L15.0761 13.9375L18.6487 17.5013C18.8007 17.6532 18.8768 17.8459 18.8768 18.0794C18.8768 18.3129 18.8007 18.5057 18.6487 18.6578C18.4966 18.8099 18.3053 18.8859 18.0747 18.8859C17.8442 18.8859 17.6529 18.8099 17.501 18.6578Z"
                        fill="#97979A"
                      />
                    </svg>
                  </div>
                )}
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="Targeting Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {location.pathname.includes("targetingAnalysis") ? (
                  <img
                    src={SelectedTargetingAnalysisIcon}
                    alt="Targeting Analysis Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/Ads_dashboard/targetingAnalysis/comparison/${brand_id}`)
                    }
                  />
                ) : (
                  <img
                    src={UnSelectedTargetingAnalysisIcon}
                    alt="Targeting Analysis Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/Ads_dashboard/targetingAnalysis/comparison/${brand_id}`)
                    }
                  />
                )}
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="CST Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {location.pathname.includes("cstAnalysis") ? (
                  <div
                  className="cursor-pointer"
                  onClick={() =>
                    navigate(`/Ads_dashboard/cstAnalysis/comparison/${brand_id}`)
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M6.5215 11.9046H9.50978C9.67192 11.9046 9.8078 11.8502 9.91741 11.7413C10.0272 11.6324 10.082 11.4976 10.082 11.3368C10.082 11.1758 10.0272 11.0395 9.91741 10.9278C9.8078 10.816 9.67192 10.7601 9.50978 10.7601H6.5215C6.35936 10.7601 6.22349 10.8146 6.11388 10.9234C6.00412 11.0323 5.94924 11.1672 5.94924 11.328C5.94924 11.4889 6.00412 11.6253 6.11388 11.7369C6.22349 11.8487 6.35936 11.9046 6.5215 11.9046ZM6.5215 15.0741H8.43636C8.5985 15.0741 8.73445 15.0196 8.8442 14.9107C8.95381 14.8019 9.00862 14.667 9.00862 14.5062C9.00862 14.3452 8.95381 14.2089 8.8442 14.0973C8.73445 13.9854 8.5985 13.9295 8.43636 13.9295H6.5215C6.35936 13.9295 6.22349 13.984 6.11388 14.0929C6.00412 14.2017 5.94924 14.3366 5.94924 14.4974C5.94924 14.6584 6.00412 14.7947 6.11388 14.9063C6.22349 15.0182 6.35936 15.0741 6.5215 15.0741ZM4.41537 18.0234C4.01905 18.0234 3.68406 17.8866 3.4104 17.6129C3.13675 17.3392 2.99992 17.0043 2.99992 16.6079V3.41564C2.99992 3.01931 3.13675 2.68432 3.4104 2.41067C3.68406 2.13701 4.01905 2.00018 4.41537 2.00018H10.6391C10.8277 2.00018 11.0074 2.03408 11.1784 2.10187C11.3493 2.16951 11.507 2.2756 11.6516 2.42013L14.3773 5.14584C14.5218 5.29037 14.6279 5.44811 14.6955 5.61905C14.7633 5.78999 14.7972 5.96974 14.7972 6.15829V8.45084C14.7972 8.60946 14.7428 8.74585 14.6339 8.86001C14.525 8.97431 14.3902 9.03146 14.2294 9.03146C14.0684 9.03146 13.9321 8.97666 13.8204 8.86705C13.7086 8.75729 13.6527 8.62135 13.6527 8.45921V6.40216H11.0993C10.8998 6.40216 10.7326 6.33466 10.5977 6.19967C10.4627 6.06468 10.3952 5.8974 10.3952 5.69784V3.1447H4.41537C4.34758 3.1447 4.28552 3.17294 4.22917 3.22943C4.17268 3.28578 4.14443 3.34785 4.14443 3.41564V16.6079C4.14443 16.6757 4.17268 16.7378 4.22917 16.7941C4.28552 16.8506 4.34758 16.8789 4.41537 16.8789H9.30663C9.46877 16.8789 9.60465 16.9333 9.71426 17.0422C9.82401 17.1511 9.87889 17.2859 9.87889 17.4467C9.87889 17.6077 9.82401 17.744 9.71426 17.8557C9.60465 17.9675 9.46877 18.0234 9.30663 18.0234H4.41537ZM14.1776 16.486C14.8062 16.486 15.3387 16.269 15.7749 15.8349C16.2111 15.4009 16.4293 14.8696 16.4293 14.241C16.4293 13.6124 16.2118 13.08 15.7769 12.6437C15.3418 12.2075 14.8093 11.9894 14.1792 11.9894C13.6713 11.9894 13.17 12.1787 12.675 12.5572C12.1801 12.9359 11.9326 13.4967 11.9326 14.2394C11.9326 14.8694 12.1496 15.4013 12.5837 15.8352C13.0177 16.269 13.549 16.486 14.1776 16.486ZM18.7612 18.8175C18.6397 18.9393 18.5035 19.0002 18.3525 19.0002C18.2013 19.0002 18.0648 18.9393 17.9429 18.8175L16.1499 16.994C15.8678 17.196 15.5606 17.3527 15.2284 17.4639C14.896 17.575 14.5506 17.6305 14.1919 17.6305C13.2421 17.6305 12.4374 17.3007 11.7777 16.6409C11.118 15.9812 10.7881 15.1801 10.7881 14.2377C10.7881 13.2952 11.118 12.4941 11.7777 11.8344C12.4374 11.1747 13.2385 10.8449 14.1809 10.8449C15.1234 10.8449 15.9245 11.1747 16.5842 11.8344C17.2439 12.4941 17.5738 13.2952 17.5738 14.2377C17.5738 14.5988 17.5182 14.9467 17.4072 15.2814C17.2959 15.6161 17.1393 15.9245 16.9372 16.2067L18.7608 17.9996C18.8825 18.1211 18.9434 18.2573 18.9434 18.4081C18.9434 18.5591 18.8827 18.6956 18.7612 18.8175Z"
                      fill="white"
                    />
                  </svg>
                  </div>
                ) : (
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/Ads_dashboard/cstAnalysis/comparison/${brand_id}`)
                    }
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M6.5215 11.9046H9.50978C9.67192 11.9046 9.8078 11.8502 9.91741 11.7413C10.0272 11.6324 10.082 11.4976 10.082 11.3368C10.082 11.1758 10.0272 11.0395 9.91741 10.9278C9.8078 10.816 9.67192 10.7601 9.50978 10.7601H6.5215C6.35936 10.7601 6.22349 10.8146 6.11388 10.9234C6.00412 11.0323 5.94924 11.1672 5.94924 11.328C5.94924 11.4889 6.00412 11.6253 6.11388 11.7369C6.22349 11.8487 6.35936 11.9046 6.5215 11.9046ZM6.5215 15.0741H8.43636C8.5985 15.0741 8.73445 15.0196 8.8442 14.9107C8.95381 14.8019 9.00862 14.667 9.00862 14.5062C9.00862 14.3452 8.95381 14.2089 8.8442 14.0973C8.73445 13.9854 8.5985 13.9295 8.43636 13.9295H6.5215C6.35936 13.9295 6.22349 13.984 6.11388 14.0929C6.00412 14.2017 5.94924 14.3366 5.94924 14.4974C5.94924 14.6584 6.00412 14.7947 6.11388 14.9063C6.22349 15.0182 6.35936 15.0741 6.5215 15.0741ZM4.41537 18.0234C4.01905 18.0234 3.68406 17.8866 3.4104 17.6129C3.13675 17.3392 2.99992 17.0043 2.99992 16.6079V3.41564C2.99992 3.01931 3.13675 2.68432 3.4104 2.41067C3.68406 2.13701 4.01905 2.00018 4.41537 2.00018H10.6391C10.8277 2.00018 11.0074 2.03408 11.1784 2.10187C11.3493 2.16951 11.507 2.2756 11.6516 2.42013L14.3773 5.14584C14.5218 5.29037 14.6279 5.44811 14.6955 5.61905C14.7633 5.78999 14.7972 5.96974 14.7972 6.15829V8.45084C14.7972 8.60946 14.7428 8.74585 14.6339 8.86001C14.525 8.97431 14.3902 9.03146 14.2294 9.03146C14.0684 9.03146 13.9321 8.97666 13.8204 8.86705C13.7086 8.75729 13.6527 8.62135 13.6527 8.45921V6.40216H11.0993C10.8998 6.40216 10.7326 6.33466 10.5977 6.19967C10.4627 6.06468 10.3952 5.8974 10.3952 5.69784V3.1447H4.41537C4.34758 3.1447 4.28552 3.17294 4.22917 3.22943C4.17268 3.28578 4.14443 3.34785 4.14443 3.41564V16.6079C4.14443 16.6757 4.17268 16.7378 4.22917 16.7941C4.28552 16.8506 4.34758 16.8789 4.41537 16.8789H9.30663C9.46877 16.8789 9.60465 16.9333 9.71426 17.0422C9.82401 17.1511 9.87889 17.2859 9.87889 17.4467C9.87889 17.6077 9.82401 17.744 9.71426 17.8557C9.60465 17.9675 9.46877 18.0234 9.30663 18.0234H4.41537ZM14.1776 16.486C14.8062 16.486 15.3387 16.269 15.7749 15.8349C16.2111 15.4009 16.4293 14.8696 16.4293 14.241C16.4293 13.6124 16.2118 13.08 15.7769 12.6437C15.3418 12.2075 14.8093 11.9894 14.1792 11.9894C13.6713 11.9894 13.17 12.1787 12.675 12.5572C12.1801 12.9359 11.9326 13.4967 11.9326 14.2394C11.9326 14.8694 12.1496 15.4013 12.5837 15.8352C13.0177 16.269 13.549 16.486 14.1776 16.486ZM18.7612 18.8175C18.6397 18.9393 18.5035 19.0002 18.3525 19.0002C18.2013 19.0002 18.0648 18.9393 17.9429 18.8175L16.1499 16.994C15.8678 17.196 15.5606 17.3527 15.2284 17.4639C14.896 17.575 14.5506 17.6305 14.1919 17.6305C13.2421 17.6305 12.4374 17.3007 11.7777 16.6409C11.118 15.9812 10.7881 15.1801 10.7881 14.2377C10.7881 13.2952 11.118 12.4941 11.7777 11.8344C12.4374 11.1747 13.2385 10.8449 14.1809 10.8449C15.1234 10.8449 15.9245 11.1747 16.5842 11.8344C17.2439 12.4941 17.5738 13.2952 17.5738 14.2377C17.5738 14.5988 17.5182 14.9467 17.4072 15.2814C17.2959 15.6161 17.1393 15.9245 16.9372 16.2067L18.7608 17.9996C18.8825 18.1211 18.9434 18.2573 18.9434 18.4081C18.9434 18.5591 18.8827 18.6956 18.7612 18.8175Z"
                      fill="#97979A"
                    />
                  </svg>
                  </div>
                )}
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="Placement Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {/* UnSelected Icon */}
                <div
                  className="cursor-pointer"
                  onClick={() =>
                    navigate(`/Ads_dashboard/placementAnalysis/comparison/${brand_id}`)
                  }
                >
                {location.pathname.includes('placementAnalysis') ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <path d="M3.50166 16.5167C3.08118 16.5167 2.72576 16.3714 2.43543 16.0809C2.14509 15.7904 1.99992 15.4348 1.99992 15.014V5.49539C1.99992 5.07459 2.14509 4.72019 2.43543 4.43219C2.72576 4.14418 3.08118 4.00018 3.50166 4.00018H17.4982C17.9187 4.00018 18.2741 4.14543 18.5644 4.43592C18.8547 4.72642 18.9999 5.08206 18.9999 5.50286V15.0215C18.9999 15.4423 18.8547 15.7967 18.5644 16.0847C18.2741 16.3727 17.9187 16.5167 17.4982 16.5167H3.50166ZM3.50166 15.3024H17.4982C17.5701 15.3024 17.6359 15.2724 17.6957 15.2125C17.7557 15.1527 17.7856 15.0868 17.7856 15.0149V5.50193C17.7856 5.43 17.7557 5.36415 17.6957 5.30437C17.6359 5.24444 17.5701 5.21447 17.4982 5.21447H3.50166C3.42974 5.21447 3.36389 5.24444 3.30411 5.30437C3.24417 5.36415 3.2142 5.43 3.2142 5.50193V15.0149C3.2142 15.0868 3.24417 15.1527 3.30411 15.2125C3.36389 15.2724 3.42974 15.3024 3.50166 15.3024ZM10.8331 14.1635H15.9072C16.1213 14.1635 16.301 14.0921 16.4464 13.9492C16.592 13.8062 16.6648 13.6278 16.6648 13.4139V10.0207C16.6648 9.8068 16.5933 9.62707 16.4504 9.48152C16.3073 9.33611 16.1288 9.26341 15.9149 9.26341H10.8406C10.6267 9.26341 10.447 9.33487 10.3014 9.47778C10.1559 9.62069 10.0831 9.79902 10.0831 10.0128V13.4062C10.0831 13.6201 10.1546 13.7998 10.2977 13.9452C10.4406 14.0907 10.6191 14.1635 10.8331 14.1635ZM11.2974 12.9492V10.4775H15.4505V12.9492H11.2974Z" fill="white"/>
                </svg>
                ): (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M3.50166 16.5167C3.08118 16.5167 2.72576 16.3714 2.43543 16.0809C2.14509 15.7904 1.99992 15.4348 1.99992 15.014V5.49539C1.99992 5.07459 2.14509 4.72019 2.43543 4.43219C2.72576 4.14418 3.08118 4.00018 3.50166 4.00018H17.4982C17.9187 4.00018 18.2741 4.14543 18.5644 4.43592C18.8547 4.72642 18.9999 5.08206 18.9999 5.50286V15.0215C18.9999 15.4423 18.8547 15.7967 18.5644 16.0847C18.2741 16.3727 17.9187 16.5167 17.4982 16.5167H3.50166ZM3.50166 15.3024H17.4982C17.5701 15.3024 17.6359 15.2724 17.6957 15.2125C17.7557 15.1527 17.7856 15.0868 17.7856 15.0149V5.50193C17.7856 5.43 17.7557 5.36415 17.6957 5.30437C17.6359 5.24444 17.5701 5.21447 17.4982 5.21447H3.50166C3.42974 5.21447 3.36389 5.24444 3.30411 5.30437C3.24417 5.36415 3.2142 5.43 3.2142 5.50193V15.0149C3.2142 15.0868 3.24417 15.1527 3.30411 15.2125C3.36389 15.2724 3.42974 15.3024 3.50166 15.3024ZM10.8331 14.1635H15.9072C16.1213 14.1635 16.301 14.0921 16.4464 13.9492C16.592 13.8062 16.6648 13.6278 16.6648 13.4139V10.0207C16.6648 9.8068 16.5933 9.62707 16.4504 9.48152C16.3073 9.33611 16.1288 9.26341 15.9149 9.26341H10.8406C10.6267 9.26341 10.447 9.33487 10.3014 9.47778C10.1559 9.62069 10.0831 9.79902 10.0831 10.0128V13.4062C10.0831 13.6201 10.1546 13.7998 10.2977 13.9452C10.4406 14.0907 10.6191 14.1635 10.8331 14.1635ZM11.2974 12.9492V10.4775H15.4505V12.9492H11.2974Z"
                    fill="#97979A"
                  />
                </svg>)}
                </div>
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="Mapping Data" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
                
              >
                {/* UnSelected Icon */}
                <div className="" onClick={() =>
                    navigate(`/Ads_dashboard/mapping/${brand_id}`)
                  }>
                    {location.pathname.includes("mapping") ? ( 
                      <img
                      src={SelectedMappingData}
                      alt="OverView Icon"
                      style={{ cursor: "pointer" }}
                    />
                    ) : (
                  <img
                    src={UnSelectedMappingData}
                    alt="OverView Icon"
                    style={{ cursor: "pointer" }}
                  />
                    )}
                </div>
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="BSR Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
                
              >
                {/* UnSelected Icon */}
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M10.4931 17.7219L8.93295 18.9089C8.77287 19.0264 8.61848 19.0305 8.46977 18.9211C8.32107 18.8117 8.27296 18.6607 8.32545 18.4681L8.93856 16.5255L7.40275 15.4604C7.24283 15.3429 7.19067 15.1936 7.24625 15.0123C7.30183 14.831 7.4329 14.7403 7.63946 14.7403H9.47877L10.058 12.85L6.74455 10.371C6.5089 10.2152 6.3259 10.005 6.19556 9.74039C6.06522 9.47581 6.00005 9.20847 6.00005 8.93836V3.56792C6.00005 3.13513 6.15323 2.76565 6.45957 2.45946C6.76576 2.15328 7.13517 2.00018 7.56779 2.00018H13.4185C13.8511 2.00018 14.2205 2.15328 14.5267 2.45946C14.833 2.76565 14.9862 3.13513 14.9862 3.56792V8.93836C14.9862 9.20213 14.919 9.46566 14.7846 9.72894C14.6502 9.99205 14.463 10.1998 14.2229 10.3523L10.9283 12.85L11.5075 14.7403H13.3468C13.5534 14.7403 13.6844 14.831 13.74 15.0123C13.7956 15.1936 13.7434 15.3429 13.5835 15.4604L12.0477 16.5255L12.6608 18.4681C12.7133 18.6607 12.6652 18.8117 12.5165 18.9211C12.3678 19.0305 12.2134 19.0264 12.0533 18.9089L10.4931 17.7219ZM7.2677 3.56792V8.93836C7.2677 9.04839 7.28712 9.13842 7.32596 9.20847C7.36464 9.27851 7.43274 9.33856 7.53025 9.38862L9.85931 11.0743V3.26783H7.56779C7.48019 3.26783 7.40828 3.29595 7.35205 3.35218C7.29581 3.40841 7.2677 3.48032 7.2677 3.56792ZM13.4185 3.26783H11.127V11.0743L13.456 9.38862C13.5698 9.33856 13.6419 9.27851 13.6725 9.20847C13.7032 9.13842 13.7186 9.04839 13.7186 8.93836V3.56792C13.7186 3.48032 13.6904 3.40841 13.6342 3.35218C13.578 3.29595 13.5061 3.26783 13.4185 3.26783Z"
                      fill="#97979A"
                    />
                  </svg>
                </div>
              </Tooltip>

              <Tooltip
                title={<IconTooltip name="SFR Analysis" />}
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                {/* UnSelected Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M2.61499 15.9587C2.44072 15.9587 2.29468 15.9002 2.17687 15.7832C2.0589 15.6662 1.99992 15.5212 1.99992 15.3484C1.99992 15.1754 2.0589 15.0288 2.17687 14.9088C2.29468 14.7887 2.44072 14.7286 2.61499 14.7286H10.2599C10.4342 14.7286 10.5802 14.7871 10.698 14.9041C10.8159 15.0211 10.8748 15.1661 10.8748 15.3389C10.8748 15.5119 10.8159 15.6584 10.698 15.7785C10.5802 15.8986 10.4342 15.9587 10.2599 15.9587H2.61499ZM2.61499 11.8006C2.44072 11.8006 2.29468 11.7421 2.17687 11.625C2.0589 11.508 1.99992 11.3631 1.99992 11.1902C1.99992 11.0172 2.0589 10.8707 2.17687 10.7507C2.29468 10.6305 2.44072 10.5704 2.61499 10.5704H5.67216C5.84643 10.5704 5.99255 10.6289 6.11052 10.7459C6.22833 10.863 6.28724 11.0079 6.28724 11.1808C6.28724 11.3538 6.22833 11.5004 6.11052 11.6205C5.99255 11.7406 5.84643 11.8006 5.67216 11.8006H2.61499ZM2.61499 7.64241C2.44072 7.64241 2.29468 7.5839 2.17687 7.46688C2.0589 7.35001 1.99992 7.20507 1.99992 7.03206C1.99992 6.85905 2.0589 6.71254 2.17687 6.59252C2.29468 6.47234 2.44072 6.41226 2.61499 6.41226H5.67216C5.84643 6.41226 5.99255 6.47077 6.11052 6.58779C6.22833 6.70481 6.28724 6.84983 6.28724 7.02284C6.28724 7.19569 6.22833 7.34221 6.11052 7.46238C5.99255 7.5824 5.84643 7.64241 5.67216 7.64241H2.61499ZM12.2778 13.1471C11.1445 13.1471 10.1785 12.7508 9.37989 11.9581C8.58108 11.1653 8.18167 10.2021 8.18167 9.06844C8.18167 7.93465 8.58179 6.97316 9.38202 6.18397C10.1822 5.39478 11.15 5.00018 12.2854 5.00018C13.4208 5.00018 14.3861 5.39604 15.1812 6.18775C15.9764 6.97947 16.374 7.93993 16.374 9.06915C16.374 9.52415 16.3055 9.95636 16.1684 10.3658C16.0314 10.7752 15.8367 11.1491 15.5844 11.4876L18.7906 14.6666C18.9301 14.7981 18.9999 14.9399 18.9999 15.0919C18.9999 15.244 18.9314 15.3885 18.7943 15.5256C18.6653 15.6566 18.5209 15.7221 18.3609 15.7221C18.201 15.7221 18.0513 15.656 17.9117 15.5237L14.7055 12.3664C14.3609 12.6128 13.9839 12.8045 13.5745 12.9415C13.1651 13.0786 12.7328 13.1471 12.2778 13.1471ZM12.2778 11.917C13.074 11.917 13.7507 11.641 14.3081 11.089C14.8654 10.537 15.1441 9.8652 15.1441 9.07364C15.1441 8.28209 14.8654 7.61031 14.3081 7.05832C13.7507 6.50633 13.074 6.23034 12.2778 6.23034C11.4817 6.23034 10.805 6.50633 10.2476 7.05832C9.69042 7.61031 9.41182 8.28209 9.41182 9.07364C9.41182 9.8652 9.69042 10.537 10.2476 11.089C10.805 11.641 11.4817 11.917 12.2778 11.917Z"
                    fill="#97979A"
                  />
                </svg>
              </Tooltip>
            </div>
          </div>

          <div className="flex flex-col items-start gap-6">
          <Tooltip
                title={
                <RangeToolTip2 
                  lastest_Refresh_Date={new Date()} 
                  Ads_Range={{min_date: new Date(2025, 1, 1), max_date: new Date()}}  
                  Seller_Range={{min_date: new Date(2025, 1, 1), max_date: new Date()}}
                  Vendor_Range={{min_date: new Date(2025, 1, 1), max_date: new Date()}} />
                }
                placement="right"
                arrow
                sx={{
                  bgcolor: "#3C3C3F",
                  padding: "8px",
                  display: "inline-flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                }}
              >
                <div
                  className="cursor-pointer"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M18.3334 10C18.3334 5.39767 14.6024 1.66671 10 1.66671C5.39765 1.66671 1.66669 5.39767 1.66669 10C1.66669 14.6024 5.39765 18.3334 10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10Z" stroke="#FFF" stroke-width="1.5"/>
                    <path d="M10.2019 14.1667V10C10.2019 9.60718 10.2019 9.41076 10.0798 9.28873C9.95779 9.16669 9.76137 9.16669 9.36853 9.16669" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.99337 6.66669H10.0009" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </Tooltip>
            
            {/* <img
              src={UserProfile}
              alt="User Profile Icon"
              style={{ cursor: "pointer" }}
              //   onClick={() => setdatename("BASE")}
            /> */}
          </div>
        </div>
      </div>
      <div
        // className="w-calc(100vw - 43px)"
        style={{
          height: "calc(100vh - 72px)",
          width: "calc(100vw - 43px)",
        }}
      >
        {/* <div
          className="flex px-[40px] w-full py-2 justify-between items-center self-stretch"
          style={{
            borderBottom: "1px solid #EAEAED",
            backgroundColor: "#FFF",
          }}
        >
          <div className="flex items-center gap-4">
            <div
              style={{
                color: "var(--Text-Primary-Grey, #97979A)",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "20px",
              }}
            >
              Ads Dashboard
            </div>
            <div className="flex justify-center items-center gap-2">
              <div className="flex items-center gap-2">
                <div
                  style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  LAST UPDATED ON 22.45,{" "}
                  {`${String(
                    Brandrange && Brandrange?.max_date.getDate()
                  ).padStart(2, "0")}/${String(
                    Brandrange && Brandrange?.max_date.getMonth() + 1
                  ).padStart(2, "0")}/${
                    Brandrange && Brandrange?.max_date.getFullYear()
                  } `}
                </div>
                <Tooltip
                  // title={"Smaple"}
                  title={
                    <RangeTooltip
                      date1={`${String(
                        Brandrange && Brandrange?.min_date.getDate()
                      ).padStart(2, "0")}/${String(
                        Brandrange && Brandrange?.min_date.getMonth() + 1
                      ).padStart(2, "0")}/${
                        Brandrange && Brandrange?.min_date.getFullYear()
                      } `}
                      date2={`${String(
                        Brandrange && Brandrange?.max_date.getDate()
                      ).padStart(2, "0")}/${String(
                        Brandrange && Brandrange?.max_date.getMonth() + 1
                      ).padStart(2, "0")}/${
                        Brandrange && Brandrange?.max_date.getFullYear()
                      } `}
                    />
                  }
                  placement="bottom"
                  arrow
                  sx={{
                    bgcolor: "#3C3C3F",
                    padding: "16px",
                    display: "inline-flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    borderRadius: "8px",
                    fontSize: "12px",
                    fontWeight: "500",
                    fontStyle: "normal",
                    lineHeight: "18px",
                    color: WHITE.W_100,
                  }}
                >
                  <img
                    src={IIcon}
                    alt="OverView Icon"
                    style={{ cursor: "pointer" }}
                    //   onClick={() => setdatename("BASE")}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div
              className="flex w-[29px] items-center gap-2 self-stretch"
              style={{
                borderRight: "1px solid #EAEAED",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <rect
                  x="4.33301"
                  y="13.668"
                  width="2"
                  height="2"
                  stroke="#97979A"
                />
                <rect
                  x="4.33337"
                  y="8.99994"
                  width="2"
                  height="2"
                  stroke="#97979A"
                />
                <rect
                  x="4.33301"
                  y="4.33203"
                  width="2"
                  height="2"
                  stroke="#97979A"
                />
                <rect x="9" y="13.668" width="2" height="2" stroke="#97979A" />
                <rect x="9" y="8.99994" width="2" height="2" stroke="#97979A" />
                <rect x="9" y="4.33203" width="2" height="2" stroke="#97979A" />
                <rect
                  x="13.667"
                  y="13.668"
                  width="2"
                  height="2"
                  stroke="#97979A"
                />
                <rect
                  x="13.6666"
                  y="8.99994"
                  width="2"
                  height="2"
                  stroke="#97979A"
                />
                <rect
                  x="13.667"
                  y="4.33203"
                  width="2"
                  height="2"
                  stroke="#97979A"
                />
              </svg>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2">
                <img
                  src="/asian.png"
                  className="h-[28px] flex-shrink-0"
                  alt="Asian"
                />
                <div className="flex flex-col">
                  <div
                    style={{
                      color: "var(--Text-Primary-Black, #1C1C1E)",
                      fontFamily: "Inter",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "18px",
                    }}
                  >
                    Asian Footwear
                  </div>
                  <div
                    style={{
                      color: "var(--Text-Primary-Grey, #97979A)",
                      fontFamily: "Inter",
                      fontSize: "10px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "10px",
                      letterSpacing: "1.6px",
                      textTransform: "uppercase",
                    }}
                  >
                    Amazon
                  </div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.56246 12.0625L6.54163 9.04165C6.49996 8.99998 6.46871 8.95484 6.44788 8.90623C6.42704 8.85762 6.41663 8.80554 6.41663 8.74998C6.41663 8.63887 6.45482 8.54165 6.53121 8.45831C6.6076 8.37498 6.70829 8.33331 6.83329 8.33331H13.1666C13.2916 8.33331 13.3923 8.37498 13.4687 8.45831C13.5451 8.54165 13.5833 8.63887 13.5833 8.74998C13.5833 8.77776 13.5416 8.87498 13.4583 9.04165L10.4375 12.0625C10.368 12.1319 10.2986 12.1805 10.2291 12.2083C10.1597 12.2361 10.0833 12.25 9.99996 12.25C9.91663 12.25 9.84024 12.2361 9.77079 12.2083C9.70135 12.1805 9.6319 12.1319 9.56246 12.0625Z"
                    fill="#1C1C1E"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>  */}
        <Outlet />
      </div>
    </div>
  );
};

export default Ads_Dashboard_Management;
